import { graphql } from "gql";

const USER_ATTRIBUTE_CATEGORY_QUERY = graphql(`
  query UserAttributeCategory($id: [ID!]!) {
    userAttributeCategory(id: $id) {
      ...UserAttributeCategory
    }
  }
`);

export default USER_ATTRIBUTE_CATEGORY_QUERY;
